//static data set for state(interval)
export const chartDays = [
    {
        label: "1D",
        value: 1,
    },
    {
        label: "1W",
        value: 7,
    },
    {
        label: "1M",
        value: 30,
    },
    {
        label: "6M",
        value: 180,
    },
    {
        label: "1Y",
        value: 365,
    },
];
